import { jsx as r, jsxs as E } from "react/jsx-runtime";
import { F as j } from "./index-gVtEopq1.js";
import * as h from "react";
import { useMemo as P, useCallback as C } from "react";
import { InputThemeEnum as M, InputSizeEnum as v } from "./shared/input/types.js";
import { LabeledJsonInput as F } from "./shared/labeled-json-input/LabeledJsonInput.component.js";
import { LabeledSelect as W } from "./shared/labeled-select/LabeledSelect.component.js";
import { LabeledBooleanInput as A } from "./shared/labeled-text-input/LabeledBooleanInput.component.js";
import { LabeledNumberInput as H } from "./shared/labeled-text-input/LabeledNumberInput.component.js";
import { LabeledTextInput as T } from "./shared/labeled-text-input/LabeledTextInput.component.js";
import { LabeledTextArea as J } from "./shared/labeled-textarea/LabeledTextarea.component.js";
import { SelectThemeEnum as Z, SelectSizeEnum as $ } from "./shared/select/types.js";
import { TextareaThemeEnum as O } from "./shared/textarea/types.js";
import { useBoolean as R, buildLabelFromName as G, isNotNil as K } from "./shared/utils.js";
import { c as I } from "./index-C3-ZVs5E.js";
import { InputLabelWrapper as Q } from "./shared/input-label-wrapper/InputLabelWrapper.component.js";
import { S as U } from "./down-arrow-CNVCC5Vu.js";
import { Button as X } from "./shared/button/Button.component.js";
import { ButtonSizeEnum as Y, ButtonThemeEnum as D } from "./shared/button/types.js";
import { S as L } from "./bin-icon-BRJxUkLh.js";
import './assets/StepParamInput.css';const g = (t) => /* @__PURE__ */ h.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ h.createElement("path", { d: "M6.99969 12.9764C10.2634 12.9764 12.9762 10.2694 12.9762 6.99994C12.9762 3.73619 10.2574 1.02344 6.99369 1.02344C3.72444 1.02344 1.02344 3.73619 1.02344 6.99994C1.02344 10.2694 3.73019 12.9764 6.99969 12.9764ZM6.99419 7.87894C6.68344 7.87894 6.51369 7.69719 6.50169 7.38644L6.41969 4.49244C6.40794 4.16994 6.65394 3.94169 6.98794 3.94169C7.31619 3.94169 7.56794 4.17594 7.55644 4.49819L7.47419 7.38694C7.46244 7.70319 7.28669 7.87919 6.99394 7.87919M6.99394 10.0354C6.65394 10.0354 6.33744 9.76594 6.33744 9.40244C6.33744 9.03919 6.64819 8.76994 6.99394 8.76994C7.33369 8.76994 7.64994 9.03344 7.64994 9.40244C7.64994 9.77169 7.32769 10.0354 6.99394 10.0354Z", fill: "#00FFF0" })), ee = (t) => /* @__PURE__ */ h.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ h.createElement("path", { d: "M8.16669 11.6668V10.5002H9.91669C10.082 10.5002 10.2206 10.4442 10.3326 10.3322C10.4446 10.2202 10.5004 10.0817 10.5 9.91683V8.75016C10.5 8.38072 10.607 8.0453 10.8209 7.74391C11.0347 7.44252 11.3167 7.22864 11.6667 7.10225V6.89808C11.3167 6.77169 11.0347 6.5578 10.8209 6.25641C10.607 5.95502 10.5 5.61961 10.5 5.25016V4.0835C10.5 3.91822 10.444 3.77977 10.332 3.66816C10.22 3.55655 10.0816 3.50055 9.91669 3.50016H8.16669V2.3335H9.91669C10.4028 2.3335 10.816 2.50364 11.1563 2.84391C11.4965 3.18419 11.6667 3.59739 11.6667 4.0835V5.25016C11.6667 5.41544 11.7227 5.55408 11.8347 5.66608C11.9467 5.77808 12.0851 5.83389 12.25 5.8335H12.8334V8.16683H12.25C12.0847 8.16683 11.9463 8.22283 11.8347 8.33483C11.7231 8.44683 11.6671 8.58527 11.6667 8.75016V9.91683C11.6667 10.4029 11.4965 10.8161 11.1563 11.1564C10.816 11.4967 10.4028 11.6668 9.91669 11.6668H8.16669ZM4.08335 11.6668C3.59724 11.6668 3.18405 11.4967 2.84377 11.1564C2.50349 10.8161 2.33335 10.4029 2.33335 9.91683V8.75016C2.33335 8.58489 2.27735 8.44644 2.16535 8.33483C2.05335 8.22322 1.91491 8.16722 1.75002 8.16683H1.16669V5.8335H1.75002C1.9153 5.8335 2.05394 5.7775 2.16594 5.6655C2.27794 5.5535 2.33374 5.41505 2.33335 5.25016V4.0835C2.33335 3.59739 2.50349 3.18419 2.84377 2.84391C3.18405 2.50364 3.59724 2.3335 4.08335 2.3335H5.83335V3.50016H4.08335C3.91808 3.50016 3.77963 3.55616 3.66802 3.66816C3.55641 3.78016 3.50041 3.91861 3.50002 4.0835V5.25016C3.50002 5.61961 3.39308 5.95502 3.17919 6.25641C2.9653 6.5578 2.68335 6.77169 2.33335 6.89808V7.10225C2.68335 7.22864 2.9653 7.44252 3.17919 7.74391C3.39308 8.0453 3.50002 8.38072 3.50002 8.75016V9.91683C3.50002 10.0821 3.55602 10.2207 3.66802 10.3327C3.78002 10.4447 3.91846 10.5006 4.08335 10.5002H5.83335V11.6668H4.08335Z", fill: "#00FFF0" })), te = "_label_a9bse_2", re = "_icon_a9bse_9", ne = "_logicLanguages_a9bse_12", se = "_language_a9bse_21", ae = "_selected_a9bse_31", oe = "_deleteButton_a9bse_43", i = {
  label: te,
  icon: re,
  logicLanguages: ne,
  language: se,
  selected: ae,
  deleteButton: oe
}, me = "_wrapper_5qkxw_2", ce = "_label_5qkxw_6", le = "_expandButton_5qkxw_9", pe = "_icon_5qkxw_24", ie = "_isExpanded_5qkxw_30", de = "_fieldWrapper_5qkxw_40", be = "_sideLine_5qkxw_47", ue = "_arrow_5qkxw_50", _e = "_toNestedObject_5qkxw_72", m = {
  wrapper: me,
  label: ce,
  expandButton: le,
  icon: pe,
  isExpanded: ie,
  fieldWrapper: de,
  sideLine: be,
  arrow: ue,
  toNestedObject: _e
}, Ce = ({
  field: t,
  value: e,
  id: o,
  labelText: d,
  copies: w,
  onChange: c
}) => {
  const [a, , , l] = R(!0), u = P(
    () => Object.fromEntries(
      typeof e == "object" && e !== null && "Object.fromEntries" in e && Array.isArray(e["Object.fromEntries"]) ? e["Object.fromEntries"] : []
    ),
    [e]
  ), b = C(
    (s, _) => {
      const x = {
        ...u,
        [s]: _
      };
      c(t.fieldName, {
        "Object.fromEntries": Object.entries(x)
      });
    },
    [t.fieldName, u, c]
  );
  return /* @__PURE__ */ r("div", { className: m.wrapper, children: /* @__PURE__ */ E(Q, { id: o, labelText: d, className: m.label, children: [
    /* @__PURE__ */ r(
      "button",
      {
        className: I(m.expandButton, {
          [m.isExpanded]: a
        }),
        onClick: l,
        type: "button",
        children: /* @__PURE__ */ r(U, { className: m.icon })
      }
    ),
    a && t.properties.map((s, _) => /* @__PURE__ */ E("div", { className: m.fieldWrapper, children: [
      /* @__PURE__ */ r(
        "div",
        {
          className: I(m.arrow, {
            [m.toNestedObject]: s.type === "object"
          })
        }
      ),
      _ !== t.properties.length - 1 && /* @__PURE__ */ r("div", { className: m.sideLine }),
      /* @__PURE__ */ r(
        fe,
        {
          field: s,
          value: u[s.fieldName],
          onChange: b,
          error: "",
          copies: w
        }
      )
    ] }, s.fieldName))
  ] }) });
}, Ne = {
  "json-logic": "json",
  js: "js",
  static: "text"
}, fe = ({
  value: t,
  field: e,
  onChange: o,
  onLogicLanguageChange: d,
  error: w,
  logicLanguage: c,
  logicLanguageOptions: a,
  copies: l,
  enableDeleteField: u,
  onDeleteField: b
}) => {
  var k;
  const s = C(
    (n) => {
      o(e.fieldName, n);
    },
    [e.fieldName, o]
  ), _ = C(
    (n) => {
      o(e.fieldName, n == null ? void 0 : n.value);
    },
    [e.fieldName, o]
  ), x = C(
    (n) => {
      o(e.fieldName, n);
    },
    [e.fieldName, o]
  ), S = C(() => {
    b == null || b(e.fieldName);
  }, [e.fieldName, b]), V = u && !e.required, B = P(
    () => /* @__PURE__ */ E("span", { className: i.label, children: [
      e.required ? /* @__PURE__ */ r(g, { className: i.icon }) : "",
      e.type === "object" ? /* @__PURE__ */ r(ee, { className: i.icon }) : "",
      G(e.fieldName),
      (a == null ? void 0 : a.length) && a.length > 1 && /* @__PURE__ */ r("span", { className: i.logicLanguages, children: a == null ? void 0 : a.map((n) => /* @__PURE__ */ r(
        "span",
        {
          className: I(i.language, {
            [i.selected]: n === c
          }),
          onClick: (N) => {
            N.stopPropagation(), N.preventDefault(), d == null || d(e.fieldName, n);
          },
          children: Ne[n]
        },
        n
      )) }),
      V && /* @__PURE__ */ r(
        X,
        {
          type: "button",
          theme: D.naked,
          "aria-label": l.deleteField,
          size: Y.xs,
          className: i.deleteButton,
          onClick: S,
          children: /* @__PURE__ */ r(L, { className: "fill-danger" })
        }
      )
    ] }),
    [
      l.deleteField,
      e.fieldName,
      e.required,
      e.type,
      S,
      c,
      a,
      d,
      V
    ]
  ), y = {
    id: `${e.fieldName}Input`,
    labelText: B,
    error: w
  }, p = {
    ...y,
    inputSize: v.md,
    inputTheme: M.secondary,
    placeholder: l.stepParamPlaceholder(e.fieldName)
  };
  if (c === "js")
    return /* @__PURE__ */ r(
      J,
      {
        ...p,
        placeholder: l.stepParamJsPlaceholder,
        onInput: s,
        value: t == null ? void 0 : t.toString(),
        textareaTheme: O.secondary
      }
    );
  if (c === "json-logic")
    return /* @__PURE__ */ r(
      F,
      {
        ...p,
        initialContent: t ?? {},
        onChange: x
      }
    );
  if (e.type === "array")
    return /* @__PURE__ */ r(
      T,
      {
        ...p,
        value: JSON.stringify(t),
        readOnly: !0
      }
    );
  if (e.type === "object")
    return /* @__PURE__ */ r(
      Ce,
      {
        id: y.id,
        labelText: B,
        field: e,
        value: t,
        copies: l,
        onChange: o
      }
    );
  if (e.type === "Enum") {
    const n = (k = e.values) == null ? void 0 : k.map((f, z) => {
      var q;
      return {
        label: "valuesLabels" in e && ((q = e.valuesLabels) == null ? void 0 : q[z]) || f,
        value: f
      };
    }), N = n == null ? void 0 : n.find((f) => f.value === t);
    return /* @__PURE__ */ r(
      W,
      {
        ...y,
        options: n,
        required: e.required,
        value: N,
        size: $.md,
        theme: Z.primary,
        onChange: _
      }
    );
  }
  return e.type === j.Boolean ? /* @__PURE__ */ r(
    A,
    {
      ...p,
      onInput: s,
      value: K(t) && t !== "" ? !!t : void 0
    }
  ) : e.type === j.Float ? /* @__PURE__ */ r(
    H,
    {
      ...p,
      type: "float",
      onInput: s,
      value: Number(t)
    }
  ) : e.type === j.Integer ? /* @__PURE__ */ r(
    H,
    {
      ...p,
      type: "integer",
      onInput: s,
      value: Number(t)
    }
  ) : /* @__PURE__ */ r(
    T,
    {
      ...p,
      onInput: s,
      value: t == null ? void 0 : t.toString()
    }
  );
};
export {
  fe as S,
  Ce as a
};
